import { TypeAheadInput } from "@visiblethread/react-components";
import clsx from "clsx";
import { bool, func, string } from "prop-types";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomers } from "slices/opportunity/customers/actions";
import { selectCustomers } from "slices/opportunity/customers/selectors";

import classes from "./CustomerField.module.scss";

const CustomerField = ({ onChange, value, labelClassName, isUsGovCon }) => {
  const dispatch = useDispatch();
  const customers = useSelector(selectCustomers);
  const inputRef = useRef(null);
  const [hasFocus, setHasFocus] = useState(false);

  const usGovConlabel = isUsGovCon ? "Agency" : "Customer";

  useEffect(() => {
    dispatch(fetchCustomers());
  }, []);

  const customerNames = useMemo(
    () =>
      customers
        .filter((customer) => customer?.name)
        .map((customer) => customer.name),
    [customers]
  );
  const handleValueChange = (event) => {
    const next = event?.target ? event.target.value : event;
    if (!hasFocus && inputRef.current?.focus) {
      inputRef.current.focus();
    }
    onChange(next);
  };

  return (
    <div className={classes.customer_field}>
      <div className={clsx(classes.customer_field__label, labelClassName)}>
        {usGovConlabel}
      </div>

      <div>
        <TypeAheadInput
          ref={inputRef}
          labelClassName={labelClassName}
          placeholder={usGovConlabel}
          value={value || ""}
          onChange={handleValueChange}
          onFocus={() => setHasFocus(true)}
          onBlur={() => setHasFocus(false)}
          options={customerNames}
        />
      </div>
    </div>
  );
};

export default CustomerField;

CustomerField.propTypes = {
  onChange: func,
  value: string,
  labelClassName: string,
  isUsGovCon: bool,
};
